import React from "react";
import { FaRandom, FaSave } from "react-icons/fa";

import { FORMULAS } from "../data/repartitionData";

const inputClass =
  "min-h-10 w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-xs font-bold text-slate-900 shadow-sm outline-none transition focus:border-orange-400 focus:ring-2 focus:ring-orange-200 dark:border-white/10 dark:bg-slate-900 dark:text-white dark:focus:ring-orange-500/20";

const GlobalAssignBar = ({ form, setForm, selectedCount, onSubmit }) => {
  const isNC = form.formule_repartition === "non_classes";

  return (
    <div className="mt-3 rounded-2xl border border-orange-200 bg-orange-50/80 p-3 shadow-sm dark:border-orange-400/20 dark:bg-orange-500/10">
      <div className="grid grid-cols-1 gap-2 lg:grid-cols-[1fr_180px_auto] lg:items-end">
        <div>
          <label className="mb-1 block text-[10px] font-bold uppercase tracking-[0.16em] text-orange-700 dark:text-orange-300">
            Formule de répartition
          </label>

          <select
            className={inputClass}
            value={form.formule_repartition || ""}
            onChange={(event) =>
              setForm((current) => ({
                ...current,
                formule_repartition: event.target.value,
              }))
            }
          >
            {FORMULAS.map((formula) => (
              <option key={formula.value} value={formula.value}>
                {formula.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="mb-1 block text-[10px] font-bold uppercase tracking-[0.16em] text-orange-700 dark:text-orange-300">
            Tapis
          </label>

          <input
            type="number"
            className={inputClass}
            value={isNC ? "" : form.numero_tapis || ""}
            disabled={isNC}
            onChange={(event) =>
              setForm((current) => ({
                ...current,
                numero_tapis: event.target.value,
              }))
            }
            placeholder={isNC ? "Auto 0" : "ex : 1"}
          />
        </div>

        <button
          type="button"
          onClick={onSubmit}
          disabled={selectedCount === 0}
          className={`inline-flex min-h-10 items-center justify-center gap-2 rounded-xl px-4 py-2 text-sm font-bold text-white shadow-sm transition ${
            selectedCount === 0
              ? "cursor-not-allowed bg-slate-400"
              : "bg-orange-600 hover:bg-orange-700"
          }`}
          title="Les compétiteurs sélectionnés seront mélangés aléatoirement avant enregistrement."
        >
          {selectedCount > 0 ? (
            <FaRandom className="h-4 w-4" />
          ) : (
            <FaSave className="h-4 w-4" />
          )}
          Créer la distribution ({selectedCount})
        </button>
      </div>

      <p className="mt-2 text-xs font-semibold text-orange-800 dark:text-orange-200">
        Tirage aléatoire : l’ordre des compétiteurs sélectionnés est mélangé
        avant la création de la poule ou du tableau.
      </p>
    </div>
  );
};

export default GlobalAssignBar;